import type {
  PersonConnectRecruitments, ProcessingSelectionStatusResponse,
  ShowPersonConnectRecruitmentResponse, IsAbleToAccessResponse
} from '../types/entries';
import type { ResponseIsAlreadyConnected } from '../types/scoutPage';
import { Response } from '../types/recruitmentShow';
import { wrapFetch } from '../libs/fetch';

export const fetchPersonConnectRecruitments = async () => {
  return await wrapFetch<PersonConnectRecruitments>('/api/v1/person_connect_recruitments');
};

export const fetchPersonConnectRecruitmentsByParam = async (params: string) => {
  return await wrapFetch<PersonConnectRecruitments>(`/api/v1/person_connect_recruitments/?${params}`);
};

export const fetchPersonConnectRecruitmentsCount = async (params: string, signal?: AbortSignal) => {
  return await wrapFetch<{ totalCount: number }>(`/api/v1/person_connect_recruitments/count?${params}`, { signal });
};

export const fetchPersonConnectRecruitmentsPersonCount = async (
  ids: number[],
  csrfToken: string,
  signal?: AbortSignal
) => {
  return await wrapFetch<{ personCount: number }>('/api/v1/person_connect_recruitments/person_count', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify({ ids }),
    credentials: 'same-origin',
    signal,
  });
};

export const fetchPersonConnectRecruitment = async (id: number) => {
  return await wrapFetch<ShowPersonConnectRecruitmentResponse>(`/api/v1/person_connect_recruitments/${id}`);
};

export const updatePersonConnectRecruitments = async (id: number, body: string, csrfToken: string) => {
  return await wrapFetch<ProcessingSelectionStatusResponse>(`/api/v1/person_connect_recruitments/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body,
    credentials: 'same-origin',
  });
};

export const fetchIsAbleToAccessConnect = async (id: number) => {
  return await wrapFetch<IsAbleToAccessResponse>(`/api/v1/person_connect_recruitments/${id}/is_able_to_access`);
};

export const postAlreadyRead = async (id: number, csrfToken: string) => {
  return await wrapFetch<{}>(`/api/v1/person_connect_recruitments/${id}/read`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    credentials: 'same-origin',
  });
};

export const fetchAlreadyConnected = async (personId: number) => {
  return await wrapFetch<ResponseIsAlreadyConnected>(`/api/v1/person_connect_recruitments/${personId}/fetch_already_connected`);
};

export const recordForDropout = async (recruitmentId: number, csrfToken: string, entry_route?: number) => {
  const body: Record<string, unknown> = {
    recruitment_id: recruitmentId,
  };

  if (entry_route !== undefined) {
    body.entry_route = entry_route;
  }
  return await wrapFetch<Response>('/api/v1/person_connect_recruitments/record_for_dropout', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify(body),
    credentials: 'same-origin',
  });
};

export const postConnectRecruitment = async (body: object, csrfToken: string) => {
  return await wrapFetch<Response>('/person_connect_recruitments', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify(body),
    credentials: 'same-origin',
  });
};
